//时间处理
var time = {};
// 格式化时间
// 参数： d  number 必需   初始化时间的毫秒数
//       s string  非必需   用于数字间分割的标识符      默认-
//      t boolean 非必需  用于判断是否需要时分秒的布尔值    默认false
//     f boolean 非必需  用于判断是否需要时不满十位前面加0的布尔值    默认做处理false
time.format = function(d, s = '-', { t = false } = {}, { f = false } = {}) {
  d = d - 0;
  if (d > 1) {
    let time = new Date(d);
    let year = time.getFullYear();
    let month = util.repair2ten(time.getMonth() + 1, f);
    let day = util.repair2ten(time.getDate(), f);
    if (!t) {
      return year + s + month + s + day;
    } else {
      let hour = util.repair2ten(time.getHours(), f);
      let minute = util.repair2ten(time.getMinutes(), f);
      let second = util.repair2ten(time.getSeconds(), f);
      return year + s + month + s + day + ' ' + hour + ':' + minute + ':' + second;
    }
  } else {
    return new Error();
  }
};

// 通用类型
var util = {
  compareObj(a, b) {
    //判断类型
    let typeofA = typeof a;
    let typeofB = typeof b;
    if (typeofA !== typeofB) {
      return false;
    }

    if (a === b) {
      return true;
    }

    if (Array.isArray(a) && Array.isArray(b) && a.length === b.length) {
      for (let i = 0, len = a.length; i < len; i++) {
        if (!this.compareObj(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }

    if (Object.prototype.toString.call(a) === '[object Object]' && Object.prototype.toString.call(b) === '[object Object]') {
      for (let key of Object.keys(a)) {
        if (!this.compareObj(a[key], b[key])) {
          return false;
        }
      }
      return true;
    }
  }
};
// 补充10一下的数字成两位字符
// 参数： num  number 必需   初始化时间的毫秒数
//      b boolean 非必需  用于判断是否不做处理    默认false
util.repair2ten = function(num, { b = false } = {}) {
  if (num === 0 || num === '0') {
    return '00';
  }
  num = num - 0;
  if (num >= 1) {
    if (num > 9 || b) {
      return '' + num;
    } else {
      return '0' + num;
    }
  } else {
    return new Error();
  }
};
util.throttle = function(func, wait) {
  var timeout, context, args;
  var previous = 0;
  var later = function() {
    previous = +new Date();
    timeout = null;
    func.apply(context, args);
  };
  var throttled = function() {
    var now = +new Date();
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      func.apply(context, args);
    } else if (!timeout) {
      timeout = setTimeout(later, remaining);
    }
  };
  return throttled;
};
/**
 * 通用异常处理，异常信息上报
 * common handle error function, report error to skywalking
 *
 * @param {string} name -异常名称
 * @param {unknown} error -异常信息
 * @param {string} [category='js'] -异常类型, 'js', 'ajax', 'client', 'vue', 'resource'
 * @param {number} [level=3] -异常等级, 0-Emergency, 1-Alert, 2-Critical, 3-Error, 4-Warning, 5-Notice, 6-Info
 * @param {unknown} content -异常上下文内容
 * @return {ErrorData}
 */
util.handleError = (name, error, category = 'js', level = 3, content) => {
  const err = error;
  if (level < 4) {
    console.error(name, err, content);
  } else if (level === 4) {
    console.warn(name, err, content);
  } else {
    console.log(name, err, content);
  }
  if (process.env.NODE_ENV !== 'development') {
    window.ClientMonitor = window.ClientMonitor||{};
    window.ClientMonitor.reportFrameErrors = window.ClientMonitor.reportFrameErrors||function() {};
    window.ClientMonitor.reportFrameErrors(
      {
        category: category,
        grade: 'Error',
        level: level,
        content: JSON.stringify(content),
      },
      {
        name: name,
        message: err.message,
        stack: err.stack,
      }
    );
  }
  return err;
};

// 将日期格式从 YYYYMMDD 转换为 YYYY-MM-DD
util.formatDate = function (dateString) {
  const dateStrYearPos = 4;
  const dateStrMonthPos = 6;
  const dateStrDayPos = 8;
  // 提取年份、月份和日期
  const year = dateString.substring(0, dateStrYearPos);
  const month = dateString.substring(dateStrYearPos, dateStrMonthPos);
  const day = dateString.substring(dateStrMonthPos, dateStrDayPos);

  // 返回格式化后的日期字符串
  return `${year}-${month}-${day}`;
}

export default {
  time,
  util
};



// WEBPACK FOOTER //
// ./src/utils/util.js